import React from 'react';
import geminiGenerated from './assets/animations/ai-generated-graphic.png';
import logo from './assets/general/compliance-graphic.png';
import UsdRateDisplay from './UsdRateDisplay';

const HeroSectionV2 = ({ isArabic }) => {
  const companyName = {
    en: {
      line1: "Al Nakhla",
      line2: "Exchange &",
      line3: "Financial Services"
    },
    ar: {
      line1: "شركة النخلة للصرافة",
      line2: "",
      line3: "",
      line4: ""
    }
  };

  const text = {
    en: {
      brandNameLine1: companyName.en.line1,
      brandNameLine2: companyName.en.line2,
      brandNameLine3: companyName.en.line3,
      tagline: "",
      taglineContinue: "To meet the needs of individuals and companies\ninside and outside Libya.",
      checkRates: "Check Exchange Rates"
    },
    ar: {
      brandNameLine1: companyName.ar.line1,
      tagline: "",
      taglineContinue: "لتلبية احتياجات الأفراد والشركات\nداخل ليبيا وخارجها.",
      checkRates: "تحقق من أسعار الصرف"
    }
  };

  const currentLang = isArabic ? 'ar' : 'en';

  return (
    <div id="hero-section" className="relative min-h-screen bg-white overflow-hidden" style={{ paddingTop: '80px' }}>
      {/* Full Width Background Image */}
      <div className="absolute inset-0">
        <img 
          src={geminiGenerated} 
          alt="Professional office environment" 
          className="w-full h-full object-cover"
          fetchPriority="high"
        />
      </div>

      {/* White Shadow Layer for Price Display - hidden on mobile */}
      <div className="hidden lg:block absolute top-0 right-0 w-80 h-full bg-gradient-to-l from-white via-white/90 to-transparent z-5"></div>

      {/* Content Layer */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl h-full" dir="ltr">
        <div className="flex flex-col lg:flex-row items-center lg:items-center justify-between min-h-[calc(100vh-80px)] py-8 lg:py-0">
          
          {/* Left side - Text and buttons on image */}
          <div className={`space-y-4 sm:space-y-6 lg:pr-8 w-full lg:${isArabic ? 'w-96' : 'w-2/3'} ${isArabic ? 'mr-auto' : ''}`} dir="ltr">
            {/* Logo and Title Layout */}
            <div className={`flex ${isArabic ? 'items-center justify-start' : 'items-center justify-start'} gap-4 sm:gap-6`}>
              <img src={logo} alt="Al Nakhla Exchange" className="w-20 h-20 sm:w-28 sm:h-28 lg:w-36 lg:h-36 object-contain flex-shrink-0 brightness-105" fetchPriority="high" />
              <div className={`flex flex-col ${isArabic ? '' : ''}`}>
                <h1 className={`${isArabic ? 'text-xl sm:text-2xl md:text-3xl lg:text-4xl' : 'text-xl sm:text-2xl md:text-3xl lg:text-4xl'} font-bold text-white leading-tight drop-shadow-lg ${isArabic ? 'text-right' : 'text-left'}`}>
                  {text[currentLang].brandNameLine1}
                </h1>
                {!isArabic && (
                  <>
                    <h2 className={`text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-white leading-tight drop-shadow-lg ${isArabic ? 'text-right' : 'text-left'}`}>
                      {text[currentLang].brandNameLine2}
                    </h2>
                    <h3 className={`text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-white leading-tight drop-shadow-lg ${isArabic ? 'text-right' : 'text-left'}`}>
                      {text[currentLang].brandNameLine3}
                    </h3>
                  </>
                )}
              </div>
            </div>
            
            {/* Row 2: Tagline */}
            <div className={`space-y-2 ${isArabic ? 'flex flex-col items-end' : ''}`}>
              <p className={`text-base sm:text-lg md:text-xl lg:text-2xl text-white leading-relaxed drop-shadow-md ${isArabic ? 'text-right' : 'text-left'}`} dir={isArabic ? 'rtl' : 'ltr'}>
                {text[currentLang].tagline}
              </p>
              <p className={`text-base sm:text-lg md:text-xl lg:text-2xl text-white leading-relaxed drop-shadow-md ${isArabic ? 'text-right' : 'text-left'}`} dir={isArabic ? 'rtl' : 'ltr'}>
                {currentLang === 'en' ? (
                  <>
                    To meet the needs of individuals and companies<br />
                    inside and outside Libya.
                  </>
                ) : (
                  <>
                    لتلبية احتياجات الأفراد <br />
                    والشركات داخل ليبيا وخارجها.
                  </>
                )}
              </p>
            </div>

            {/* Row 3: Button */}
            <div className={`flex ${isArabic ? 'justify-end' : 'justify-start'}`}>
              <a 
                href="https://cbl.gov.ly/currency-exchange-rates/"
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 py-2.5 sm:px-6 sm:py-3 text-sm sm:text-base text-white font-semibold rounded-lg transition-all duration-300 hover:shadow-lg transform hover:scale-105 shadow-lg"
                style={{ backgroundColor: '#006655' }}
              >
                {text[currentLang].checkRates}
              </a>
            </div>
          </div>

          {/* Right side - Price display on white shadow */}
          <div className="w-full lg:w-1/3 flex justify-center lg:justify-end relative z-20 mt-8 lg:mt-0 lg:mb-16" dir="ltr">
            {/* Exchange Rate Display */}
            <div className="pt-4">
              <UsdRateDisplay isArabic={isArabic} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSectionV2;